/* unplugin-vue-components disabled */import script from "./SellPointAndMaterials.vue?vue&type=script&setup=true&lang=js"
export * from "./SellPointAndMaterials.vue?vue&type=script&setup=true&lang=js"

import "./SellPointAndMaterials.vue?vue&type=style&index=0&id=a7542fa2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7542fa2"]])

export default __exports__